import { render, staticRenderFns } from "./tickets-list.vue?vue&type=template&id=6406b1d9"
import script from "./tickets-list.vue?vue&type=script&lang=js"
export * from "./tickets-list.vue?vue&type=script&lang=js"
import style0 from "./tickets-list.vue?vue&type=style&index=0&id=6406b1d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports